<template>
    <div
		ref="scheduleScroll"
        class="main-div"
    >
        <div
            :style="dayStyle(item)"
            class="pl-2 pr-2 container-days"
            v-for="item in servicesScheduled" :key="item.day"
			:id="'day-'.concat(item.day)"
            @click="clickShowDay(item)"
        >
            <label class="label-weekDay">
                {{ item.weekDay }}
            </label>
            <label class="ml-3 mr-3 label-day">
                {{ item.day }}
            </label>
            <div
                v-if="item.scheduled"
                class="schedule-div"
            >
                <div
                    v-for="(scheduled, index) in item.scheduled" :key="index" :style="dayStyle(item)"
                >
                    <label class="mt-0 mb-0">
                        {{ scheduled.scheduleStartTime }} - {{ scheduled.customer }} ({{ scheduled.service }})
                    </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
	export default {
		components: {

		},

		name: "ShowDayInLine",
		props: {
			options: {
				type: Object,
				required: false
			},
			color: {
				type: String,
				default: "black"
			},
			backColor: {
				type: String,
				default: "rgb(245, 255, 255)"
			},
			colorTextDay: {
				type: String,
				default: "black"
			},
			cursor: {
				type: String,
				default: "pointer"
			},
			dateSearch: {
				type:Date,
				required: true
			},
			changeMonth: {
				type: Number,
				required: true
			}
		},

		data () {
			return {

			};
		},

		watch: {
			changeMonth () {
				this.getDayShow();
			}
		},

		computed: {
			servicesScheduled () {
				const date = new Date(this.dateSearch);

				return this.options.servicesScheduled.reduce((acc, ele) => {
					if (!ele.show) return acc;

					date.setDate(ele.day);
					const weekDay = this.options.diasSemana[date.getDay()].label;
					acc.push({
						...ele,
						weekDay
					});

					return acc;

				}, []);
			}
		},

		async mounted () {
			await this.waitRenderComplete();
			await this.getDayShow();
		},

		methods: {
			async getDayShow () {
				const today = new Date();
				const dateSearch = new Date(this.dateSearch);

				const currentYear = today.getFullYear();
				const currentMonth = today.getMonth();
				let currentDay = today.getDate();

				const searchYear = dateSearch.getFullYear();
				const searchMonth = dateSearch.getMonth();

				if (currentMonth !== searchMonth || currentYear !== searchYear) {
					currentDay = 1;
				}

				const id = "day-".concat(currentDay);
				const element = await this.waitElement(id);
				this.setDayShow(element);

				return true;
			},

			setDayShow (el) {
				try {
					const container = this.$refs.scheduleScroll;

					const navbar = document.querySelector(".navbar");
					const navbarHeight = navbar ? navbar.offsetHeight : 0;
					const titleMonth = document.querySelector(".title-month");
					const titleMonthHeight = titleMonth ? titleMonth.offsetHeight : 0;

					const offsetTop = el.offsetTop;

					container.scrollTo({
						top: offsetTop - (navbarHeight + titleMonthHeight),
						behavior: "smooth"
					});
				} catch (e) {
					if (!el) this.getDayShow();

					return null;
				}
			},

			async waitRenderComplete () {
				await this.$nextTick();
				await new Promise(r => requestAnimationFrame(r));
				await this.$nextTick();
			},

			async waitElement (id) {
				await this.waitRenderComplete();
				return document.getElementById(id);
			},

			clickShowDay (item) {
				this.$emit("clickShowDayInLine", { ...item });
			},

			dayStyleText (item) {
				return { color: item.colorTextDay || this.colorTextDay };
			},

			dayStyle (item) {
				return {
					background: item.backColor || this.backColor,
					cursor: "pointer",
					"white-space": "nowrap",
					color: item.color || this.color
				};
			}
		}
	};
</script>

<style scoped>
	.main-div {
		background: var(--cal-header-color);
		width: 100%;
		padding-top: 1px;
		height: calc(100vh - (2.5rem + 65px));
		overflow-y: auto;
		overflow-x: hidden;
	}

	.container-days {
		display: flex;
		min-height: 2.75rem;
		max-height: 7.75rem;
		background: white;
		width: 100%;
		align-items: center;
		border: solid 1px var(--cal-header-color);
		border-top: 0px;
		border-radius: 3px;
	}

	.schedule-div {
		width: 100%;
		min-height: 2.5rem;
		max-height: 7.5rem;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.label-weekDay {
		font-size: 1rem;
		font-weight: 600;
		width: 2rem;
	}

	.label-day {
		font-size: 1rem;
		font-weight: 600;
	}
</style>